$(() => {

  // Elements
  const $window = $(window);
  const $body = $("body");
  const $help = $("form#help", $body);

  if ($help.length > 0) {
    const $inputs = $("input", $help);

    // Set everything on unchecked on page reload
    $inputs.prop("checked", false);

    $inputs.change(event => {
      $(`[data-name=${event.target.getAttribute("name")}]`, $help).show();
    });
  }

});


// WEBPACK FOOTER //
// ./js/help.js